import InventoryIcon from '@material-ui/icons/InsertChart';

export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      role: 'admin',
      icon: 'icon-home',
      wrapper: {
        element: '',
        attributes: {},
      },
      class: ''
    },

    {
      name: 'Tasks',
      titre: true,
      role: 'admin',
      icon: 'icon-layers',
      wrapper: {
        element: '',
        attributes: {},
      },
      class: '',
      children: [
        {
          name: 'Initiates',
          url: '/tasks/initiates',
          role: 'admin',
          icon: 'icon-puzzle',
        },
        {
          name: 'In progress',
          url: '/tasks/inprogress',
          role: 'admin',
          icon: 'icon-social-dropbox',
        },
        {
          name: 'Completed',
          url: '/tasks/completed',
          role: 'admin',
          icon: 'icon-handbag',
        },
        {
          name: 'All tasks',
          url: '/all_tasks',
          role: 'admin',
          icon: 'icon-list',
        },
      ]
    },
    {
      name: 'Items',
      role: 'super_admin',
      icon: 'icon-location-pin',
      wrapper: {
        element: '',
        attributes: {},
      },
      class: '',

      children: [
        {
          name: 'List items',
          role: 'super_admin',
          url: '/items',
          icon: 'icon-list',
        },
        {
          name: 'Add item',
          role: 'super_admin',
          url: '/addItem',
          icon: 'icon-settings',
        },
        {
          name: 'Categories',
          role: 'super_admin',
          url: '/categories',
          icon: 'icon-list',
        },
      ]
    },

    {
      name: 'Reporting',
      role: 'super_admin',
      icon: 'icon-calendar',
      wrapper: {
        element: '',
        attributes: {},
      },
      class: '',

      children: [
        {
          name: 'Tasks tracking ',
          role: 'super_admin',
          url: '/tasks_tracking',
          icon: 'icon-calendar',
        },
        {
          name: 'CheckList tracking ',
          role: 'super_admin',
          url: '/checklist_tracking',
          icon: 'icon-calendar',
        },
      ]
    },
    {
      name: 'Admin',
      role: 'super_admin',
      icon: 'icon-speedometer',
      wrapper: {
        element: '',
        attributes: {},
      },
      class: '',

      children: [
        {
          name: 'Users',
          role: 'super_admin',
          url: '/users',
          icon: 'icon-people',
        },
        {
          name: 'AddUser',
          role: 'super_admin',
          url: '/addUser',
          icon: 'icon-user-follow',
        },

      ]
    },

  ],
};
